var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "#ffda00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-15.332031-1.351562-30.347656-3.933594-44.933594l-120.566406-120.566406-263 331 86.566406 86.566406c14.585938 2.582032 29.601563 3.933594 44.933594 3.933594 141.386719 0 256-114.613281 256-256zm0 0",
    fill: "#ffc200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m124.5 90.5h263v331h-263zm0 0",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m255.644531 90.5h131.855469v331h-131.855469zm0 0",
    fill: "#f2f6fc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bec3d2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155 127.769531h202v21.464844h-202zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155 174.046875h202v21.464844h-202zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155 220.320312h202v21.464844h-202zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155 266.597656h202v21.464844h-202zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155 312.875h202v21.464844h-202zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155 362.765625h202v21.464844h-202zm0 0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m255.644531 127.769531h101.355469v21.464844h-101.355469zm0 0",
    fill: "#afb4c8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m255.644531 174.046875h101.355469v21.464844h-101.355469zm0 0",
    fill: "#afb4c8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m255.644531 220.320312h101.355469v21.464844h-101.355469zm0 0",
    fill: "#afb4c8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m255.644531 266.597656h101.355469v21.464844h-101.355469zm0 0",
    fill: "#afb4c8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m255.644531 312.875h101.355469v21.464844h-101.355469zm0 0",
    fill: "#afb4c8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m255.644531 362.765625h101.355469v21.464844h-101.355469zm0 0",
    fill: "#afb4c8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m443.175781 292.539062c0 50.96875-41.316406 92.285157-92.285156 92.285157s-92.285156-41.316407-92.285156-92.285157 41.316406-92.285156 92.285156-92.285156 92.285156 41.316406 92.285156 92.285156zm0 0",
    fill: "#fe6a16"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m443.175781 292.539062c0-50.933593-41.257812-92.226562-92.285156-92.285156v184.566406c51.027344-.058593 92.285156-41.351562 92.285156-92.28125zm0 0",
    fill: "#f24500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m409.09375 257.667969-23.332031-23.335938-34.871094 34.871094-34.871094-34.871094-23.332031 23.335938 34.867188 34.871093-34.867188 34.867188 23.332031 23.335938 34.871094-34.871094 34.871094 34.871094 23.332031-23.335938-34.871094-34.867188zm0 0",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m409.09375 257.667969-23.332031-23.335938-34.871094 34.871094v46.667969l34.871094 34.871094 23.332031-23.335938-34.871094-34.867188zm0 0",
    fill: "#f2f6fc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.564c337ab1c2ae8f3f1cef2c4404e970.svg";
export { ForwardRef as ReactComponent };